import React, { Component } from 'react';
import qs from 'qs';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  compact,
  isBoolean,
  isNaN,
  get,
  noop,
  omit,
  pick,
  sumBy,
  orderBy,
  groupBy
} from 'lodash';
import { Element } from 'react-scroll';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import moment from 'moment';
import ReactGA from 'react-ga';
import MuiBadge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Collapse from '@material-ui/core/Collapse';
import { grey700, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Delete from '@material-ui/icons/Delete';
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown';
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp';
import Store from '@material-ui/icons/Store';
import LocalShipping from '@material-ui/icons/LocalShipping';

import immutableToJS from 'helpers/immutableToJS';
import { isMobile } from 'helpers/detect-mobile';
import {
  dispatchRestMaker,
  scrollTo,
  formatPhoneNumber,
  getCartLocalStorage,
  setCartLocalStorage,
  clearCartLocalStorage,
  checkIsAddedABox,
  toStartCase
} from 'helpers/utils';
import {
  Avatar,
  HighlightText,
  injectIntl,
  InvoiceBadge,
  OrderCart,
  ProfileBanner,
  Tooltip,
  Badge,
  FilterCategory,
} from 'components';
import ordersActions, { hasDeliveryFeeOrder } from 'redux/orders/actions';
import { sellersItemsActions } from 'redux/sellers/actions';
import { refreshToken } from 'redux/auth/actions';
import { selectState } from 'redux/selectors';
import OrderSheetCardDetail from './OrderSheetCardDetail';
import { ifError } from 'assert';
import ShowMoreText from 'react-show-more-text';
import CategoryDrawer from './CategoryDrawer';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  badge: {
    backgroundColor: '#00c308',
    color: 'white',
    fontSize: 15,
    left: 10,
  },
  cardAction: {
    borderRadius: '50% !important;',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;',
    marginTop: 0,
  },
  cardHeaderRoot: {
    paddingTop: 11,
    paddingBottom: 11,
  },
  cardHeader: { width: '100%' },
  cardMedia: { position: 'relative' },
  cardTitle: {
    [theme.breakpoints.down('md')]: {
      fontSize: '0.875rem',
      lineHeight: 0,
    },
  },
  collapseWrapperInner: {
    display: 'flex',
  }
});

class OrderSheetCard extends Component {
  static contextTypes = {
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isMember: PropTypes.bool,
    setHotNotification: PropTypes.func.isRequired,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    contact: PropTypes.shape({}).isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    deliveryDate: PropTypes.string,
    deliveryFeeOrder: PropTypes.shape({}).isRequired,
    expanded: PropTypes.bool,
    invoice: PropTypes.shape({}),
    setInvoice: PropTypes.func,
    currentOrderSheetCardId: PropTypes.number,
    cartEmpty: PropTypes.bool,
    setOpen: PropTypes.func,
    info: PropTypes.shape({
      bio: PropTypes.string,
      companyName: PropTypes.string,
      firstName: PropTypes.string,
      email: PropTypes.string,
      id: PropTypes.number,
      lastName: PropTypes.string,
      userCategory: PropTypes.string,
      userCoverImage: PropTypes.string,
    }).isRequired,
    orderRequesting: PropTypes.bool,
    searchText: PropTypes.string,
    sellersItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    sellersItemsRequesting: PropTypes.bool,
    createOrder: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    listSellersItems: PropTypes.func.isRequired,
    refreshToken: PropTypes.func.isRequired,
    setDeliveryDate: PropTypes.func.isRequired,
    hasDeliveryFeeOrder: PropTypes.func.isRequired,
    setExpanded: PropTypes.func,
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    listOrders: PropTypes.func.isRequired,
    contacts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
  };

  static defaultProps = {
    deliveryDate: '',
    invoice: { items: {} },
    setInvoice: noop,
    currentOrderSheetCardId: -1,
    cartEmpty: true,
    setOpen: noop,
    expanded: false,
    orderRequesting: false,
    searchText: '',
    sellersItems: [],
    sellersItemsRequesting: false,
    setExpanded: noop,
    contacts: [],
  };

  state = {
    isOpenCartDialog: false,
    isPlaceOrderButtonDisabled: false,
    isOpenMergeInvoicesDialog: false,
    ordersForDeliveryDate: [],
    orderMerge: -1,
    hasAnOrderedBox: false,
    isDoneWithListOrder: false,
    categoryFilter: "",
    drawerOpen: false,
    pagingOffset: 0,
  }

  componentWillMount() {
    const { isConsumer } = this.context;
    const { contacts } = this.props;
    const onlyOneVendorId = contacts && contacts.length === 1 ? contacts[0].sellerId : 0;
    const onlyOneVendorIsConsumerOff = contacts && contacts.length === 1 && !contacts[0].sellerProfile.isConsumerOff;
    if (isConsumer && onlyOneVendorId > 0 && onlyOneVendorIsConsumerOff) {
      this.handleExpandChange(onlyOneVendorId);
    }
  }

  componentDidMount() {
    const { expanded } = this.props;
    if (expanded) this.handleExpandChange(expanded);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.expanded && !this.props.expanded) {
      this.handleExpandChange(nextProps.expanded);
    }
  }

  setIsClearOrderedData = () => {
    const { invoice } = this.props;
    const itemIds = Object.keys(invoice.items);
    if (itemIds.length <= 1) {
      this.setState({ isOpenCartDialog: false });
      clearCartLocalStorage();
    }
  }

  addItem = (id, value, isBoxItem = false) => {
    const { isPublic, isConsumer, setHotNotification } = this.context;
    const { invoice, setInvoice, deliveryDate } = this.props;
    const { hasAnOrderedBox } = this.state;

    const invoiceForPublic = getCartLocalStorage(invoice);
    setCartLocalStorage(invoiceForPublic);

    let newInvoice;

    if (value === undefined || value.qty === '') {
      const items = { ...invoiceForPublic.items };
      delete items[id];
      newInvoice = {
        ...invoiceForPublic,
        items,
      };
    } else {
      newInvoice = {
        ...invoiceForPublic,
        items: {
          ...invoiceForPublic.items,
          [id]: omit(value, ['action']),
        },
      };
    }

    if (!isBoxItem) {
      const result = checkIsAddedABox(newInvoice.items);
      if (result === 0 && (isConsumer || isPublic) && !hasAnOrderedBox) {
        setHotNotification('Please order a box first');
        if (value !== undefined && value.qty !== '') {
          return;
        }
      }
    }

    setInvoice(newInvoice);
  }

  expandChange = (expanded) => {
    const { info, setExpanded } = this.props;
    setExpanded(expanded ? info.id : -1);
  };

  handleExpandChange = (defaultExpanded) => {
    const expanded = isBoolean(defaultExpanded) ? defaultExpanded : !this.props.expanded;
    const { contact, info, listSellersItems, setExpanded, currentOrderSheetCardId, cartEmpty, setOpen } = this.props;

    if (!cartEmpty) {
      setOpen(true, info.id === currentOrderSheetCardId ? -1 : info.id);
      return;
    }

    this.setState({ categoryFilter: '' });

    setExpanded(expanded ? info.id : -1);
    if (!expanded) return;

    setTimeout(() => scrollTo('go-to-scroll'), 1000);
    listSellersItems(contact.sellerId, { buyerId: contact.buyerId });
  }

  handleRefreshSellersItems = () => {
    const { contact, listSellersItems } = this.props;
    listSellersItems(contact.sellerId, { buyerId: contact.buyerId });
  }

  handleFocusSearch = (id) => {
    scrollTo(id);
  }

  handleOpenCartDialog = () => {
    const { isPublic, isConsumer, setHotNotification } = this.context;
    const { hasAnOrderedBox } = this.state;
    const invoiceFromLocalStorage = getCartLocalStorage();
    const result = checkIsAddedABox(invoiceFromLocalStorage.items);
    if (result === 0 && (isConsumer || isPublic) && !hasAnOrderedBox) {
      setHotNotification('Please order a box first');
      return;
    }

    this.setState({ isOpenCartDialog: true });
  }

  handleCloseCartDialog = () => {
    this.setState({ isOpenCartDialog: false });
  }


  handleCloseMergeInvoicesDialog = () => {
    this.setState({ isOpenMergeInvoicesDialog: false });
  }

  handlePlaceOrderButtonDisabled = (disabled) => {
    this.setState({ isPlaceOrderButtonDisabled: disabled });
  }

  handleChangeOrderMerge = (orderMerge) => {
    this.setState({ orderMerge });
  }

  pickDeliveryDate = (value) => {
    const { contact, info, setDeliveryDate, hasDeliveryFeeOrder, listOrders } = this.props;
    const { isOpenCartDialog } = this.state;

    if (!value || isNaN(value.getTime())) {
      setDeliveryDate(info.id, '');
    } else {
      const deliveryDate = moment(value).format('YYYY-MM-DD');
      setDeliveryDate(info.id, deliveryDate);
      hasDeliveryFeeOrder({
        contactId: contact.id,
        deliveryDate,
      });
      this.setState({ isDoneWithListOrder: false });
      // get orders by deliveryDate
      listOrders({
        startDate: deliveryDate,
        endDate: deliveryDate,
        buyerId: contact.buyerId,
        sellerId: contact.sellerId,
        onSuccess: (data) => {
          // open the popup
          if (data.length > 0 && !isOpenCartDialog ) {
            const sortedData = orderBy(
              data,
              'orderNum',
              'asc',
            );
            this.setState({ isOpenMergeInvoicesDialog: true, ordersForDeliveryDate: sortedData, orderMerge: sortedData[0].id });
          } else if (!isOpenCartDialog) {
            this.setState({ orderMerge: -1 });
          }

          if (data.length > 0) {
            this.setState({ hasAnOrderedBox: true });
          } else {
            this.setState({ hasAnOrderedBox: false });
          }
          this.setState({ isDoneWithListOrder: true });
        },
      });
    }
  }

  selectDeliveryType = (deliveryType) => {
    const publicInvoice = getCartLocalStorage();
    if (deliveryType) {
      publicInvoice.deliveryType = deliveryType;
      setCartLocalStorage(publicInvoice);
    }
  }

  selectFromAddressIndex = (fromAddressIndex) => {
    const publicInvoice = getCartLocalStorage();
    publicInvoice.fromAddressIndex = fromAddressIndex;
    setCartLocalStorage(publicInvoice);
  }

  selectToAddressIndex = (toAddressIndex) => {
    const publicInvoice = getCartLocalStorage();
    publicInvoice.toAddressIndex = toAddressIndex;
    setCartLocalStorage(publicInvoice);
  }

  redirectToTrackOrders = (deliveryDate, orderId) => {
    this.props.history.push({
      pathname: '/track-orders',
      state: {
        deliveryDate,
        orderId,
      },
    });
  };

  placeOrder = (data, fromAddressIndex, toAddressIndex, deliveryType, payMethod, orderMerge, handleOpenPlaceOrderDlg, handleClosePlaceOrderDlg) => {
    const { createOrder, contact, deliveryDate, listSellersItems, refreshToken, setInvoice } = this.props;
    const { buyerProfile, sellerProfile } = contact;
    const items = data.map(item => ({
      goodId: item.seller ? parseInt(item.id, 10) : null,
      packrow: pick(item, ['count', 'uom', 'pack', 'price', 'cost']),
      quantity: item.qty,
      storeItemId: !item.seller ? parseInt(item.id, 10) : null,
    })).filter(item => !!item.quantity);

    const order = {
      payMethod,
      buyerId: contact.buyerId,
      buyerAddress: buyerProfile.addresses[toAddressIndex],
      deliveryType,
      deliveryDate,
      items,
      sellerId: contact.sellerId,
      sellerAddress: sellerProfile.addresses[fromAddressIndex],
      sellerNote: data.length > 0 && data[0].sellerNote ? data[0].sellerNote : null,
      buyerNote: data.length > 0 && data[0].buyerNote ? data[0].buyerNote : null,
      noteToSeller: data.length > 0 && data[0].noteToSeller ? data[0].noteToSeller : null,
      orderMerge,
      onSuccess: (data) => {
        ReactGA.event({
          category: 'Order',
          action: 'Place order',
        });
        ReactGA.event({
          category: 'Order',
          action: 'Place Order',
          label: 'Unique # of items',
          value: items.length,
        });
        ReactGA.event({
          category: 'Order',
          action: 'Place Order',
          label: 'Total # of items',
          value: sumBy(items, 'quantity'),
        });
        setInvoice({ items: {} });
        listSellersItems(contact.sellerId, { buyerId: contact.buyerId });
        if (payMethod === 'coin') {
          refreshToken();
        }
        this.setState({ isOpenCartDialog: false });

        clearCartLocalStorage();

        const { isMember } = this.context;
        if (!isMember) {
          this.redirectToTrackOrders(deliveryDate, data.orderId);
        }
      },
      onFailure: () => {
        this.handlePlaceOrderButtonDisabled(false);
        handleClosePlaceOrderDlg();
        handleOpenPlaceOrderDlg();
      },
    };

    createOrder(order);
  }

  removeItem = (id) => {
    const { invoice, setInvoice } = this.props;
    setInvoice({
      ...invoice,
      items: omit(invoice.items, [id]),
    });

    this.setIsClearOrderedData();
  }

  handleClick = (e) => {
    const value = e.currentTarget.innerText.trim() === "All" ? "" : e.currentTarget.innerText;
    this.setState({ categoryFilter: value });
    this.setState({pagingOffset: 0});

    if (isMobile) {
      this.setState({ drawerOpen: false });
    } 
    var tableItems = document.getElementById('table-items');
    tableItems.scrollIntoView({ behavior: "smooth"});
  }

  handleDrawerClose = () => {
    this.setState({ drawerOpen: false });
  };

  handleDrawerOpen = () => {
    this.setState({ drawerOpen: true });
  };

  getListSections = () => {
    const { sellersItems } = this.props;
    const data = [];
    const groupItems = sellersItems;

    groupItems.forEach((groupItemInfo) => {

      let packrows = [];
      if (groupItemInfo.packrows[0].isBulk) {
        packrows = compact(
          groupItemInfo.packrows.map(packrow => !packrow.invalid &&
            // hide packrow with availableQuantity = 0
            (parseInt(packrow.availableQuantity) >= 1) &&
            // hide packrow with availableQuantity * count < total availableQuantity
            (parseInt(packrow.availableQuantity) * parseInt(packrow.count) <=
            parseInt(groupItemInfo.availableQuantity)) &&
            parseFloat(packrow.price, 10) > 0 &&
            (!groupItemInfo.sellerAccountId || (groupItemInfo.sellerAccountId && parseFloat(packrow.cost, 10) > 0)) && ({
            ...omit(packrow, ['id']),
            totalIndex: `${groupItemInfo.id}-${packrow.count}`,
          })),
        );
      } else {
        packrows = compact(
          groupItemInfo.packrows.map(packrow => !packrow.invalid &&
            // hide packrow with availableQuantity = 0
            (parseInt(packrow.availableQuantity) >= 1) &&
            parseFloat(packrow.price, 10) > 0 &&
            (!groupItemInfo.sellerAccountId || (groupItemInfo.sellerAccountId && parseFloat(packrow.cost, 10) > 0)) && ({
            ...omit(packrow, ['id']),
            totalIndex: `${groupItemInfo.id}-${packrow.count}`,
          })),
        );
      }

      if (packrows.length) {
        data.push(groupItemInfo);
      }
    });
    const result = (Object.keys(groupBy(data, item => item.productData.category))).sort();

    return result;
  }

  handlePagingOffset = (offset) => {
    this.setState({ pagingOffset: offset });
  }

  render() {
    const {
      classes,
      contact,
      currentUser = {},
      deliveryDate,
      deliveryFeeOrder,
      expanded,
      info,
      orderRequesting,
      searchText,
      sellersItems,
      sellersItemsRequesting,
      formatMessage,
      invoice,
    } = this.props;
    const {
      companyName,
      firstName,
      id,
      lastName,
      userCategory,
      logoUrl,
      coverImageUrl,
    } = info;
    const { isRestaurant, isConsumer } = this.context;
    const { isOpenCartDialog, isPlaceOrderButtonDisabled, isOpenMergeInvoicesDialog, ordersForDeliveryDate, orderMerge, hasAnOrderedBox, isDoneWithListOrder, categoryFilter, drawerOpen, pagingOffset } = this.state;
    const fullName = `${firstName} ${lastName}`;

    const avatar = (
      <Avatar
        fullName={companyName}
        src={logoUrl}
        style={{ marginRight: 10 }}
        size={40}
      />
    );
    const cardCover = coverImageUrl ? (
      <CardMedia
        classes={{ root: classes.cardMedia }}
        image={coverImageUrl}
      >
        <ProfileBanner
          img={coverImageUrl}
          userType={userCategory}
        />
      </CardMedia>
    ) : (
      <ProfileBanner
        img={coverImageUrl}
        userType={userCategory}
      />
    );

    const isMe = contact.requestorId === contact.buyerId;

    const invoiceForPublic = getCartLocalStorage(invoice);
    if (deliveryDate) {
      invoiceForPublic.deliveryDate = deliveryDate;
    }
    setCartLocalStorage(invoiceForPublic);

    const itemIds = Object.keys(invoiceForPublic.items);
    const orderedData = compact(
      itemIds.map(itemId => invoiceForPublic.items[itemId].qty !== undefined && ({
        ...invoiceForPublic.items[itemId],
        action: (
          <div className="group-item-action custom-action">
            <IconButton
              onClick={() => this.removeItem(itemId)}
              style={{ padding: 0 }}
            >
              <Delete color={grey700} />
            </IconButton>
          </div>
        ),
      })),
    );

    const { history } = this.props;

    const { suid } = qs.parse(history.location.search.substring(1));

    const { sellerProfile } = contact;
    const fromAddress = sellerProfile.addresses && sellerProfile.addresses.length > 0 ? sellerProfile.addresses[0] : {};
    const email = `${formatMessage('Email')}: ${sellerProfile.email}.`;
 
    const phone = `${formatMessage('Phone')}: ${formatPhoneNumber(sellerProfile.mobile)}.`;
    const organicNumber = get(sellerProfile, 'organicNumber') ? `${formatMessage('Organic Number')}: ${get(sellerProfile, 'organicNumber')}.` : '';
    const stateAndZipcode = `${fromAddress.state && fromAddress.zipcode ? `${fromAddress.state || ''} - ${fromAddress.zipcode || ''}.` : ''}`;
    const sellerAddress = `${fromAddress.address} ${stateAndZipcode} ${email} ${phone} ${organicNumber}`;
    const isOff = get(contact, 'sellerProfile.isOff');
    const isConsumerOff = get(contact, 'sellerProfile.isConsumerOff') !== undefined ? get(contact, 'sellerProfile.isConsumerOff') : true;
    const listCategories = sellersItems ? this.getListSections() : [];

    return (suid == contact.sellerId && ((isOff && !isConsumer) || (isConsumerOff && isConsumer) || contact.isDeleted)) ? (<Redirect to="/track-orders" />) : (
      <Element
        name={`order-sheets-${id}`}
        style={{ padding: '5px 0' }}
      >
        {!expanded && (
          <OrderCart>{null}</OrderCart>
        )}
        {expanded && <div name="go-to-scroll" />}
        <Card>
          <div>
          <CardHeader
            action={
              (contact.isDeleted || (!isConsumer && isOff) || (isConsumer)) ? null : (
                <IconButton
                  aria-expanded={expanded}
                  style={isRestaurant || isConsumer ? { color: 'white', backgroundColor: '#4695ec' } : null}
                  aria-label="Show more"
                  onClick={this.handleExpandChange}
                >
                  {expanded ? <CollapseIcon /> : <ExpandIcon />}
                </IconButton>
            )}
            avatar={avatar}
            classes={{
              title: classes.cardTitle,
              root: classes.cardHeaderRoot,
              action: classes.cardAction,
              content: classes.cardHeader,
            }}
            style={contact.isDeleted || (!isConsumer && isOff) || (isConsumer && isConsumerOff) ? { backgroundColor: '#e4e5e6' } : {}}
            title={
              <div style={{ alignItems: 'center' }} className="store-card-title d-flex">
                <div className="store-card-sub-title">
                  <div style={{ width: '100%', marginTop: isConsumer && isMobile ? '10px' : null }}>
                    <HighlightText
                      highlight={searchText}
                      style={{
                        color: '#000',
                      }}
                      text={companyName}
                      style={{
                        fontSize: '1.1em',
                        fontWeight: 'bold',
                      }}
                    />
                    {!isMobile && (
                      <HighlightText
                        highlight={searchText}
                        style={{
                          color: 'gray',
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                        text={fullName}
                      />
                    )}
                    {!isMobile && (
                      <HighlightText
                        highlight={searchText}
                        style={{
                          color: 'gray',
                          fontSize: 14,
                          marginLeft: 10,
                        }}
                        text={sellerAddress}
                      />
                    )}
                  </div>
                </div>
                <div className="store-card-options">
                  {
                    contact.defaultDiscount > 0 && (
                      <div className="discount-info d-md-down-none">
                        <Tooltip tooltip={formatMessage('Discount')}>
                          <Badge type="discount">
                            -{contact.defaultDiscount}&nbsp;%
                          </Badge>
                        </Tooltip>
                      </div>
                    )
                  }
                  {
                    contact.defaultDeliveryFee > 0 && (
                      <div className="discount-info deliveryFee d-md-down-none" style={{ color: green[400] }}>
                        <LocalShipping style={{ color: green[400] }} />&nbsp;
                        <span className="number" style={{ color: green[400] }}>
                          ${contact.defaultDeliveryFee.toFixed(2)}&nbsp;
                        </span>
                        {!isMobile && formatMessage('fee')}
                      </div>
                    )
                  }
                  {
                    (isRestaurant) && !isMobile && (
                      <span className="d-flex d-md-down-none" style={{ alignItems: 'center', marginRight: 10 }}>
                        <Tooltip tooltip={formatMessage('View store')}>
                          <Store style={{ color: 'rgba(0, 0, 0, 0.5)' }} />
                        </Tooltip>
                      </span>
                    )
                  }
                  {contact.isDeleted && isMe && (
                    <div className="d-md-down-none">
                      <InvoiceBadge type="deactivated">
                        {formatMessage('Blocked')}
                      </InvoiceBadge>
                    </div>
                  )}
                  {contact.isDeleted && !isMe && (
                    <InvoiceBadge type="deactivated">
                      <div className="d-sm-down-none">
                        {formatMessage('Vendor Disabled Your Ordering')}
                      </div>
                      <div className="d-md-up-none">
                        {formatMessage('Disabled')}
                      </div>
                    </InvoiceBadge>
                  )}
                  {!contact.isDeleted && ((isOff && !isConsumer) || (isConsumer && isConsumerOff)) && (
                    <InvoiceBadge type="activated">
                      <div className="d-sm-down-none">
                        {formatMessage('Ordering Now Closed')}
                      </div>
                      <div className="d-md-up-none">
                        {formatMessage('Closed')}
                      </div>
                    </InvoiceBadge>
                  )}
                </div>
              </div>
            }
          />
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
            style={{width:'100%'}}
            classes={{
              wrapperInner: classes.collapseWrapperInner,
            }}
          >
          {!isMobile &&  (
            <div className="category-container">
              <CategoryDrawer 
                products={listCategories}
                handleClick={this.handleClick}
                categoryFilter={categoryFilter}
                />
            </div>
          )}
          {isMobile && (
            <FilterCategory>
                <React.Fragment>
                  <Button onClick={this.handleDrawerOpen} className="filter-button" style={{padding:"8px"}}>
                    <span style={{marginRight: "10px"}}>Products</span>
                    <i className="arrow down"></i>
                  </Button>
                  <CategoryDrawer 
                    products={listCategories}
                    handleClick={this.handleClick}
                    categoryFilter={categoryFilter}
                    drawerOpen={drawerOpen}
                    handleDrawerClose={this.handleDrawerClose}
                  />
                </React.Fragment>
            </FilterCategory>
          )}
            <div className="d-flex store-card-options d-lg-up-none" style={{ alignItems: 'center', flexFlow: 'row wrap' }}>
              {
                !isMobile && contact.defaultDiscount > 0 && (
                  <div className="discount-info d-md-down-none" style={{ padding: '0px 0px 15px 24px' }}>
                    <Tooltip tooltip={formatMessage('Discount')}>
                      <Badge type="discount">
                        -{contact.defaultDiscount}&nbsp;%
                      </Badge>
                    </Tooltip>
                  </div>
                )
              }
              {
                !isMobile && contact.defaultDeliveryFee > 0 && (
                  <div className="d-flex discount-info d-md-down-none" style={{ alignItems: 'center', justifyContent: 'center', padding: '0px 0px 15px 24px' }}>
                    <LocalShipping style={{ color: 'rgba(0, 0, 0, 0.5' }} />&nbsp;
                    <span className="number">
                      ${contact.defaultDeliveryFee.toFixed(2)}&nbsp;
                    </span>
                    {!isMobile && formatMessage('fee')}
                  </div>
                )
              }
              {
                isRestaurant && !isMobile && (
                  <span className="d-flex" style={{ alignItems: 'center', marginRight: 10, padding: '0px 0px 15px 24px' }}>
                    <Tooltip tooltip={formatMessage('View store')}>
                      <Store style={{ color: 'rgba(0, 0, 0, 0.5)' }} />
                    </Tooltip>
                  </span>
                )
              }
              {contact.isDeleted && isMe && (
                <div style={{ padding: '0px 0px 15px 24px' }}>
                  <InvoiceBadge type="deactivated">
                    {formatMessage('Blocked')}
                  </InvoiceBadge>
                </div>
              )}
              {contact.isDeleted && !isMe && (
                <div style={{ padding: '0px 0px 15px 24px' }}>
                  <InvoiceBadge type="deactivated">
                    <div className="d-sm-down-none">
                      {formatMessage('Vendor Disabled Your Ordering')}
                    </div>
                    <div className="d-md-up-none">
                      {formatMessage('Disabled')}
                    </div>
                  </InvoiceBadge>
                </div>
              )}
              {!contact.isDeleted && ((isOff && !isConsumer) || (isConsumer && isConsumerOff)) && (
                <div style={{ padding: '0px 0px 15px 24px' }}>
                  <InvoiceBadge type="deactivated">
                    <div className="d-sm-down-none">
                      {formatMessage('Vendor Is Closed')}
                    </div>
                    <div className="d-md-up-none">
                      {formatMessage('Closed')}
                    </div>
                  </InvoiceBadge>
                </div>
              )}
             
            </div>
            <CardContent style={{ padding: '0px 0px 20px 0px', width: '100%' }}>
              {expanded && (
                <OrderSheetCardDetail
                  addItem={this.addItem}
                  contact={contact}
                  currentUser={currentUser}
                  deliveryDate={deliveryDate}
                  deliveryFeeOrdered={deliveryFeeOrder.ordered}
                  details={sellersItems}
                  expanded={expanded}
                  formatMessage={formatMessage}
                  handleFocusSearch={this.handleFocusSearch}
                  info={info}
                  invoice={invoice}
                  orderedData={orderedData}
                  orderRequesting={orderRequesting}
                  pickDeliveryDate={this.pickDeliveryDate}
                  selectDeliveryType={this.selectDeliveryType}
                  selectFromAddressIndex={this.selectFromAddressIndex}
                  selectToAddressIndex={this.selectToAddressIndex}
                  placeOrder={this.placeOrder}
                  removeItem={this.removeItem}
                  sellersItemsRequesting={sellersItemsRequesting}
                  handleRefreshSellersItems={this.handleRefreshSellersItems}
                  isOpenCartDialog={isOpenCartDialog}
                  handleOpenCartDialog={this.handleOpenCartDialog}
                  handleCloseCartDialog={this.handleCloseCartDialog}
                  isPlaceOrderButtonDisabled = {isPlaceOrderButtonDisabled}
                  handlePlaceOrderButtonDisabled={this.handlePlaceOrderButtonDisabled}
                  isOpenMergeInvoicesDialog={isOpenMergeInvoicesDialog}
                  handleCloseMergeInvoicesDialog={this.handleCloseMergeInvoicesDialog}
                  ordersForDeliveryDate={ordersForDeliveryDate}
                  orderMerge={orderMerge}
                  handleChangeOrderMerge={this.handleChangeOrderMerge}
                  hasAnOrderedBox={hasAnOrderedBox}
                  isDoneWithListOrder={isDoneWithListOrder}
                  categoryFilter={categoryFilter}
                  pagingOffsetDefault={pagingOffset}
                  handlePagingOffset={this.handlePagingOffset}
                />
              )}
            </CardContent>
          </Collapse>
          </div>
        </Card>
      </Element>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('orders', 'order')(state, 'order'),
  ...selectState('orders', 'deliveryFeeOrder')(state, 'deliveryFeeOrder'),
  ...selectState('orders', 'orders')(state, 'orders'),
  ...selectState('sellers', 'sellersItems')(state, 'sellersItems'),
});

export default compose(
  setDisplayName('OrderSheetCard'),
  connect(
    mapStateToProps,
    dispatch => ({
      ...dispatchRestMaker([
        [ordersActions, 'order'],
        [sellersItemsActions, 'sellersItem'],
      ])(dispatch),
      hasDeliveryFeeOrder: payload => dispatch(hasDeliveryFeeOrder(payload)),
      refreshToken: payload => dispatch(refreshToken(payload)),
    }),
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(OrderSheetCard);
